import { useTranslation } from "react-i18next"
import { useLocation, useNavigate } from "react-router-dom"

interface ProgressBarProps {
  sections?: readonly {
    readonly name: string
    readonly steps: readonly string[]
  }[]
  basePath?: string
}

export default function ProgressBar({
  sections,
  basePath = "/onboarding",
}: ProgressBarProps) {
  const location = useLocation()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const currentPath = location.pathname.split("/").pop() ?? ""

  if (!sections) return null

  const allSteps = sections.flatMap((section) => section.steps)
  const currentStepIndex = allSteps.indexOf(currentPath)
  const progress =
    currentStepIndex >= 0 ? ((currentStepIndex + 1) / allSteps.length) * 100 : 0

  const handleBack = () => {
    if (currentStepIndex > 0) {
      const prevStep = allSteps[currentStepIndex - 1]
      navigate(`${basePath}/${prevStep}`)
    }
  }

  return (
    <div className="flex w-full items-center gap-3">
      {currentStepIndex > 0 && (
        <button
          onClick={handleBack}
          className="hover:text-custom-charcoal shrink-0 p-1 text-gray-400 transition-colors"
          aria-label="Go back"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M15 18l-6-6 6-6" />
          </svg>
        </button>
      )}

      <div className="h-2 w-full overflow-hidden rounded-full bg-gray-100">
        <div
          className="bg-custom-teal h-full rounded-full transition-all duration-500 ease-out"
          style={{ width: `${Math.max(progress, 3)}%` }}
        />
      </div>

      <button
        onClick={() => navigate("/checkout/plans")}
        className="hover:text-custom-charcoal shrink-0 text-sm font-semibold text-gray-400 transition-colors"
      >
        {t("shared.skip", "Skip")}
      </button>
    </div>
  )
}
